// extracted by mini-css-extract-plugin
module.exports = {"loading":"PageLoading_loading__PeqDS","loadingShrink":"PageLoading_loadingShrink__3vT9M"};